import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { IBooking } from "../../shared/Domains/bookings";
import { AppServiceManager } from "common/services/appServiceManager";
import { BreadcrumbService } from "app/breadcrumb.service";
import { IUser } from "app/shared/Domains/IUser";
import { AuthService } from "common/services/auth.service";
import { LanguageService } from 'app/LanguageService/Language.Service';
declare var $: any;

@Component({
    selector: "app-bookings",
    templateUrl: "./bookings.component.html",
    styleUrls: ["./bookings.component.css"],
})
export class BookingsComponent implements OnInit {
    Booking: IBooking;
    Bookings: IBooking[] = [];;
    sourceBookings: any[] = [];
    sortedBookings: any[];
    loading: boolean;
    user: IUser;
    first: number = 0;

    constructor(
        private LanguageService: LanguageService,
        private route: Router,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private appServiceManager: AppServiceManager,
        private breadcrumbService: BreadcrumbService
    ) {
        this.breadcrumbService.setItems([
            { label: "Bookings Management" },
            { label: "All Bookings", routerLink: ["/bookings"] },
        ]);
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("BookingsComponent", label);
      }
    ngOnInit() {
        this.Booking = new IBooking();
        this.user = AuthService.getLoggedInUser();
        this.Bookings = [];
        this.loading = false;
        this.getBookingsByBranch();
        setTimeout(() => {
            let element = document.getElementsByClassName("pi-th-large")[0] as HTMLElement;
            element.click();
        }, 100);
    }

    viewBooking(booking: { _id: string; }) {
        this.route.navigateByUrl("bookings/booking/" + booking._id);
    }
    getBookingsByBranch() {
        this.loading = true;
        this.appServiceManager.get("bookings/branch/" + this.user.branch).subscribe((res: any) => {
            if (res.length > 0) {
                this.Bookings = this.sourceBookings = res;
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "info",
                    summary: "Info Message",
                    detail: "No Record Found",
                });
            }
            this.loading = false;
        },
            (error: { error: { message: any; }; }) => {
                this.loading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error.error.message,
                });
            }
        );
    }

    searchLocal(value: string, type: string) {
        let matchedName = [];
        let matchedEmail = [];
        let matchedTagNumber = [];
        if (value !== null && value !== undefined && value.toString().length > 0) {
            if (value == "") {
                this.Bookings = Object.assign([], this.sourceBookings);
            }
            if (!value) {
                this.Bookings = Object.assign([], this.sourceBookings);
            }
            if (value != "") {
                if (type === "name") {
                    matchedName = Object.assign([], this.sourceBookings).filter(
                        book => book.customer.name ? book.customer.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                    matchedEmail = Object.assign([], this.sourceBookings).filter(
                        book => book.customer.email ? book.customer.email.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                    matchedTagNumber = Object.assign([], this.sourceBookings).filter(
                        book => book.customer.tagNumber ? book.customer.tagNumber.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
                }
                const distinct = (value: any, index: any, self: string | any[]) => {
                    return self.indexOf(value) === index;
                }
                const source = matchedName.concat(matchedEmail);
                this.Bookings = source.filter(distinct);

                if (this.Bookings.length === 0) {
                    this.Bookings = [];
                    this.messageService.clear();
                    this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
                } else {
                    this.first = 0;
                    if (this.Bookings.length === 1) {
                        this.first = 0;
                    }
                    this.Bookings = [...this.Bookings];
                }
            }
        } else {
            this.Bookings = Object.assign([], this.sourceBookings);
        }
    }

    // DELETE BOOKING BY ID
    deleteBookingById(booking: { _id: string; }) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Deactivate Booking ?",
            accept: () => {
                this.loading = true;
                this.appServiceManager
                    .delete("bookings/" + booking._id)
                    .subscribe(
                        (res: any) => {
                            if (res) {
                                this.getBookingsByBranch();
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Deactivated",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                })
                            }
                            this.loading = false;
                        },
                        (error: { error: { message: any; }; }) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error.error.message,
                            });
                        }
                    );
            },
        });
    }

    approveRequest(booking: IBooking) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Approve Request ?",
            accept: () => {
                this.appServiceManager.post('bookings/bookingApproved', booking).subscribe((res: any) => {
                    if (res.message) {
                        this.messageService.clear();
                        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: res.message });
                    } else {
                        this.getBookingsByBranch();
                        this.messageService.clear();
                        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Booking Approved Successfully" });
                    }
                }, (error: { error: { message: any; }; }) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.message });
                });
            }
        });
    }

    rejectRequest(booking: IBooking) {
        this.confirmationService.confirm({
            message: "Are you sure you want to Reject Request ?",
            accept: () => {
                this.getBookingsByBranch();
                this.appServiceManager.post('bookings/bookingReject', booking).subscribe((res: any) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'success', summary: 'Success Message', detail: "Booking Reject Successfully, and also send notification to the member" });
                }, (error: { error: { message: any; }; }) => {
                    this.messageService.clear();
                    this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.message });
                });
            }
        });
    }
    resetFilter() {
        this.Booking.name = '';
        this.Bookings = this.sourceBookings;
    }

}
